var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointInverted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Point/List/White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-Kes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inspection.-Pop-Over-Minard-Select",
    transform: "translate(-436.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(432.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C13,24 13.5,23 13,22 C12.3729641,20.7459281 13.5,17.5 16,15 C18.5,12.5 20,10.7332365 20,8 C20,3.581722 16.418278,0 12,0 C7.581722,0 4,3.581722 4,8 C4,11.0068035 5.5,12.5 8,15 C10.5,17.5 11.6270359,20.7459281 11,22 C10.5,23 11,24 12,24 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.397932146,
    fill: "#644BFF",
    cx: 12,
    cy: 8,
    r: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointInverted);
export default __webpack_public_path__ + "static/media/point_inverted.99be9326ffcef14cbca70ec17d8bb639.svg";
export { ForwardRef as ReactComponent };